import { Injectable } from '@angular/core';
import { SelectInputsList } from '@portal/shared/helpers/src';
import { ISelectInput } from '@portal/shared/ui/filter';
import { Acquirer } from '../enums/acquirer.enum';

declare const $localize;
@Injectable({ providedIn: 'root' })
export class AcquirerTypes extends SelectInputsList {
  keyValue = {
    [Acquirer.AdsCa]: $localize`:Acquirer type|:ADS CA`,
    [Acquirer.AdsUs]: $localize`:Acquirer type|:ADS US`,
    [Acquirer.AnzNz]: $localize`:Acquirer type|:ANZ NZ`,
    [Acquirer.AsbNz]: $localize`:Acquirer type|:ASB NZ`,
    [Acquirer.BarclaysUK]: $localize`:Acquirer type|:Barclays UK`,
    [Acquirer.BnzNz]: $localize`:Acquirer type|:BNZ NZ`,
    [Acquirer.ChaseUS]: $localize`:Acquirer type|:Chase US`,
    [Acquirer.CuscalAu]: $localize`:Acquirer type|:Cuscal AU`,
    [Acquirer.FdrcCa]: $localize`:Acquirer type|:FDRC CA`,
    [Acquirer.FdrcUs]: $localize`:Acquirer type|:FDRC US`,
    [Acquirer.FiservAu]: $localize`:Acquirer type|:Fiserv AU`,
    [Acquirer.Intercard]: $localize`:Acquirer type|:Verifone Payments Gmbh`,
    [Acquirer.IntercardEuIcpp]: $localize`:Acquirer type|:Verifone Payments GmbH ICPP`,
    [Acquirer.IntercardEuRegular]: $localize`:Acquirer type|:Verifone Payments GmbH Regular`,
    [Acquirer.IntercardUkIcpp]: $localize`:Acquirer type|:Verifone Payments UK ICPP`,
    [Acquirer.IntercardUkRegular]: $localize`:Acquirer type|:Verifone Payments UK Regular`,
    [Acquirer.KiwibankNz]: $localize`:Acquirer type|:Kiwibank NZ`,
    [Acquirer.Landsbankinn]: $localize`:Acquirer type|:Landsbankinn`,
    [Acquirer.NabAu]: $localize`:Acquirer type|:NAB AU`,
    [Acquirer.NetsSdi]: $localize`:Acquirer type|:Nets SDI`,
    [Acquirer.OpOnlinePayment]: $localize`:Acquirer type|:OP Online Payment`,
    [Acquirer.Other]: $localize`:Acquirer type|:Other`,
    [Acquirer.Swedbank]: $localize`:Acquirer type|:Swedbank`,
    [Acquirer.SwedbankSeAdvanced]: $localize`:Acquirer type|:Swedbank SE Advanced`,
    [Acquirer.SwedbankSeAdvancedLidl]: $localize`:Acquirer type|:Swedbank SE Advanced LIDL`,
    [Acquirer.SwedbankSeAdvancedMcd]: $localize`:Acquirer type|:Swedbank SE Advanced MCD`,
    [Acquirer.SwedbankSeClassicLidlDk]: $localize`:Acquirer type|:Swedbank SE Classic LIDL DK`,
    [Acquirer.SwedbankSeClassicLidlFi]: $localize`:Acquirer type|:Swedbank SE Classic LIDL FI`,
    [Acquirer.SwedbankSeClassicLidlSe]: $localize`:Acquirer type|:Swedbank SE Classic LIDL SE`,
    [Acquirer.TillAu]: $localize`:Acquirer type|:Till AU`,
    [Acquirer.Unzer]: $localize`:Acquirer type|:Unzer`,
    [Acquirer.VerifoneEU]: $localize`:Acquirer type|:Verifone Europe`,
    [Acquirer.VerifoneUK]: $localize`:Acquirer type|:Verifone UK`,
    [Acquirer.VerifoneEuRegular]: $localize`:Acquirer type|:Verifone Europe Regular`,
    [Acquirer.VerifoneUkRegular]: $localize`:Acquirer type|:Verifone UK Regular`,
    [Acquirer.WestpacAu]: $localize`:Acquirer type|:Westpac AU`,
    [Acquirer.WestpacNz]: $localize`:Acquirer type|:Westpac NZ`,
    [Acquirer.WorldpayUS]: $localize`:Acquirer type|:Worldpay US`,
  };

  list: ISelectInput[] = this.getSelectInputs();
}
